import React, { useEffect, useRef, useState } from "react";
import Layout from "../components/Layout";
import { ProgressSpinner } from "primereact/progressspinner";
import axios from "axios";
import { BASE_URL } from "../utils/commonUrl";
import { useSelector } from "react-redux";
import { Toast } from "primereact/toast";
import "./home.css";
//import { toast } from "react-toastify";

const SelfAssessment = () => {
  const primeToast = useRef(null);
  const { user } = useSelector((state) => state["auth"]);
  const [assessment, setAssessment] = useState([]);
  const [assessmentTitles, setAssessmentTitles] = useState([]);
  const [optionList, setOptionList] = useState([]);
  const [selectedAssessment, setSelectedAssessment] = useState(0);
  const [userAssestmentOpinionID, setUserAssestmentOpinionID] = useState(0);
  const [quater, setQuater] = useState([]);
  const [assessmentIndicator, setAssessmentIndicator] = useState({
    isLoading: false,
    list: [],
  });
  const [assessmentSummary, setAssessmentSummary] = useState([]);

  useEffect(() => {
    getActiveAssessment();
    getActiveAssessmentTitles(user.registerID);
    getAssesstmentOpinionList();
    getQuarterActiveList();
    getAssessmentSummary();
  }, []);

  const getAssessmentSummary = async () => {
    try {
      const response = await axios.get(
        BASE_URL +
          "/api/assesmentinformation/GetAssesmentSummary/" +
          user.registerID
      );
      if (response.status === 200) {
        setAssessmentSummary(response.data);
      }
    } catch (e) {}
  };

  const getActiveAssessment = () => {
    axios
      .get(BASE_URL + "/api/assestment/GetActiveList")
      .then((response) => {
        setAssessment(response.data);
      })
      .catch((e) => {
        console.log(e);
      });
  };
  const getActiveAssessmentTitles = (id) => {
    axios
      .get(
        BASE_URL +
          "/api/assestment/GetUserWiseAssesmentList/"+ id)
      .then((response) => {
        //console.log("Hi");
        //console.log(response.data);
        setAssessmentTitles(response.data);
      })
      .catch((e) => {
        console.log(e);
      });
  };
  const getAssesstmentOpinionList = () => {
    axios
      .get(BASE_URL + "/api/assestmentOpinion/GetActiveList")
      .then((response) => {
        setOptionList(response.data);
      })
      .catch((e) => {
        console.log(e);
      });
  };
  //api/utility/GetAssestmentIndicator/17
  const getAssessmentIndicator = (id) => {
    setAssessmentIndicator({ isLoading: true, list: [] });
    const registerID = user.registerID;
    axios
      .post(BASE_URL + "/api/utility/GetAssestmentIndicator/", {
        RegisterID: registerID,
        AssestmentID: id,
      })
      .then((response) => {
        setAssessmentIndicator({ isLoading: false, list: response.data });
      })
      .catch((e) => {
        setAssessmentIndicator({ isLoading: false, list: [] });
        console.log(e);
      });
  };

  //api/quarter/GetActiveList
  const getQuarterActiveList = () => {
    axios
      .get(BASE_URL + "/api/quarter/GetActiveList")
      .then((response) => {
        setQuater(response.data);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const onAssessmentValueChange = (e) => {
    setSelectedAssessment(e.currentTarget.value);
    getAssessmentIndicator(e.currentTarget.value);
  };

  const onUserAssessmentChange = (e) => {
    // console.log(e.currentTarget.value)
    setUserAssestmentOpinionID(e.target.value);
    console.log(userAssestmentOpinionID);
  };

  const onFormSubmit = (e) => {
    e.preventDefault();
    const assesmentInformationID = 0;
    const quaterId = quater[0].quarterID;
    const assestmentID = selectedAssessment;
    const assestmentTitleID = assessmentIndicator.list[0].assestmentTitleID;
    const userAssestmentOpinionID = e.target.UserAssessmentId.value;

    //console.log(userAssestmentOpinionID);

    if (userAssestmentOpinionID === "-1") {
      primeToast.current.show({
        severity: "error",
        summary: "error",
        detail: "Please select Opinion",
        life: 3000,
      });
    } else {
      const json = {
        registerID: user.registerID,
        quarterID: quaterId,
        assestmentID: assestmentID,
        assestmentTitleID: assestmentTitleID,
        userAssestmentOpinionID: userAssestmentOpinionID,
      };
      const headers = {
        "Content-Type": "application/json",
      };

      console.log("else block====>", JSON.stringify(json));

      axios
        .post(
          BASE_URL + "/api/assesmentinformation/SetUserAssesment",
          JSON.stringify(json),
          { headers: headers }
        )
        .then((response) => {
          if (response.status === 200) {
            primeToast.current.show({
              severity: "success",
              summary: "success",
              detail: "Assessment Save Successfully",
              life: 3000,
            });
            getAssessmentSummary();
            getActiveAssessmentTitles(user.registerID);
          }
        })
        .catch((e) => {
          console.log(e);
          primeToast.current.show({
            severity: "error",
            summary: "error",
            detail: e.message,
            life: 3000,
          });
        });
    }
  };

  const assessmentBody = () => (
    <div className="row">
      <div className="col-sm-12 col-md-7 col-lg-7">
        {assessmentIndicator.list.length !== 0 ? (
          <div className="card-body customCardBody">
            <h5
              className="card-title"
              style={{ color: "#0b57d0", fontWeight: 700 }}
            >
              Definition:{" "}
              {assessmentIndicator.list.length === 0
                ? ""
                : assessmentIndicator.list[0].defination}
            </h5>
            <form method="post" onSubmit={onFormSubmit}>
              <div className="question-item ps-4 pt-1">
                {assessmentIndicator.list.map((question, index) => (
                  <div className="" key={index}>
                    <p>
                      <b>{question.indicatorSequenceNo}.</b>{" "}
                      {question.indicatorTitle}
                    </p>
                  </div>
                ))}

                <div className="row">
                  <div className="col-md-6 pt-3">
                    <label className="lblBlue">Select Your Opinion</label>
                    <select
                      className="form-select"
                      name="UserAssessmentId"
                      disabled={
                        parseInt(
                          assessmentSummary[0].totalSupervisorSubmission
                        ) > 0
                      }
                      defaultValue={
                        assessmentIndicator.list[0].userAssestmentOpinionID ===
                        null
                          ? -1
                          : assessmentIndicator.list[0].userAssestmentOpinionID
                      }
                      onChange={onUserAssessmentChange}
                    >
                      <option value={-1}>Select Your Opinion</option>
                      {optionList.map((value, index) => (
                        <option key={index} value={value.weight}>
                          {value.title}/{value.titleBangla}({value.weight})
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
              <div className="mt-1 ps-4  pt-3">
                {
                  user.isLocked === true ? 
                  (
                    <h2 className="notUpdateComment" style={{fontSize:"1.5rem"}}>
                      *** This Quarter Already Locked..!
                    </h2>
                  ):(
                    
                 
                parseInt(assessmentSummary[0].totalSupervisorSubmission) >
                0 ? (
                  <b className="notUpdateComment">
                   *** Your supervisor's assessment has been completed. You can not modify anything.
                  </b>
                ) : (
                  <>
                    <button type="submit" className="btn btn-primary"><i class="bi bi-check-lg"></i> 
                   { assessmentIndicator.list[0].userAssestmentOpinionID === null ? " Save" : " Update" }
                    </button>
                  </>
                )
                )}
              </div>
            </form>
          </div>
        ) : (
          <h3 className="m-5">Core Values Area </h3>
        )}
      </div>
      <div className="col-sm-12 col-md-5 col-lg-5">
        <table className="table">
          <thead>
            <tr>
              <th scope="col" className='tdCenter'>#</th>
              <th scope="col">Name</th>
              <th scope="col" className='tdCenter'>RCL</th>
              <th scope="col">Opinion</th>
              <th scope="col" className='tdCenter'>Mark</th>
            </tr>
          </thead>
          <tbody>
            {assessmentTitles.map((value, index) => (
              <tr key={index}>
                <td className='tdCenter'>{value.assesmentInformationID > 0 ? <i className="bi bi-check-circle checkSuccess"></i> : ""}</td>
                <td className='tdWhiteSpace'>{value.assestmentName}</td>
                <td className='tdCenter'>{value.rca}</td>
                <td className='tdWhiteSpace'>{value.selfOpinion}</td>
                <td className='tdCenter'>{value.opinionValue}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );

  return (
    <Layout>
      <Toast ref={primeToast} />
      <div className="card">
        <div className="card-header">
          <div className="row">
            <div className="col-md-4">
              <select
                className="form-select"
                onChange={onAssessmentValueChange}
                // disabled={assessment.length === 0}
                aria-label=".form-select-sm example"
              >
                <option value={-1}>{"-- Please Select --"}</option>
                {assessment.map((value) => (
                  <option key={value.assestmentID} value={value.assestmentID}>
                    {value.assestmentName}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-md-4">
            <b>  Completed Core Values:
              {assessmentSummary.length !== 0 ? (
                <>
                  {" "}
                  {assessmentSummary[0].totalAssestmentSubmission} out of{" "}
                  {assessmentSummary[0].totalAssestment}.{" "}
                </>
              ) : (
                ""
              )}
              </b>
            </div>

            <div className="col-md-4" style={{ textAlign: "right" }}>
              <b>Quarter:</b> {user.quarterName}/{new Date().getFullYear()}
            </div>
          </div>
        </div>
        {assessmentIndicator.isLoading ? (
          <ProgressSpinner style={{ height: 50, width: 50 }} />
        ) : (
          assessmentBody()
        )}

        {/*    card body end*/}
      </div>
    </Layout>
  );
};

export default SelfAssessment;
